export default __webpack_public_path__ + "static/kwinten_pisman-2f6d9edc32ee8a2eae67c48859c86780.jpg";